import EfBanner from '@elem/ui/ef-banner';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useProductStore } from '@elem/compPage/Rapid/ProductProvider';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.Banner');
    const { pageStatus } = useProductStore();
    const { locale = 'us' } = useRouter();

    const IS_NA_SITE = ['ca', 'us', 'mx'].includes(locale);
    const IS_EU_SITE = ['de', 'fr', 'it', 'es', 'eu', 'uk', 'kr'].includes(locale);
    const youtubeLocal = {
        // en: 'https://www.youtube.com/embed/G_43Vw0SAKU?si=F7ul1mW4HiIQ4yft',
        en: 'https://www.youtube.com/embed/A5eQbHKLpeA?si=x5c-c_nl-g822RHj',
        jp: 'https://www.youtube.com/embed/k1tFz7u1x80?si=7IAROHK0hN_TzaTp',
        de: 'https://www.youtube.com/embed/GpymJXtrH-Y?si=areq7DI8peQFpFMu',
        fr: 'https://www.youtube.com/embed/R7eAPid6Aes?si=kZrtWtwAKn5gjBKV',
        it: 'https://www.youtube.com/embed/sbztVkEhzXw?si=UP8ku4YVvT1b-iCi',
        es: 'https://www.youtube.com/embed/GzmwuQap-nE?si=YH3jVtrRfbK2GHTe',
    };

    const itemA = {
        title: t('title'),
        desc: t('desc'),
        pc:
            locale === 'kr'
                ? 'https://websiteoss.ecoflow.com/upload/image/1747966419343/PC%205120x1720.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1729481220331/1_pc.jpg',
        h5:
            locale === 'kr'
                ? 'https://websiteoss.ecoflow.com/upload/image/1747966419453/M%202048x1160.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1729481220131/1_m.jpg',
        btn_text: locale === 'kr' ? undefined : pageStatus !== 'statusA' ? t('btn') : '',
        btn_link: locale === 'kr' ? undefined : pageStatus !== 'statusA' ? youtubeLocal[locale] || youtubeLocal?.en : '',
    };
    return (
        <div className={css.comp}>
            <EfBanner {...itemA} position="hoverL" theme="black" />
            {(IS_NA_SITE || IS_EU_SITE) && <div className="explain">{t('explain')}</div>}
        </div>
    );
}
